import { enableProdMode, importProvidersFrom, provideZonelessChangeDetection } from '@angular/core';
import { environment } from './environments/environment';
import { APP_ROUTES } from './app/app.routes';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { provideRouter } from '@angular/router';
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient, withInterceptors, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AuthInterceptor, authInterceptorProviders } from './app/_helpers/auth.interceptor';
import { provideServiceWorker } from '@angular/service-worker';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
      provideZonelessChangeDetection(),
      provideServiceWorker('ngsw-worker.js'),
      importProvidersFrom(HttpClientModule),
      provideRouter(APP_ROUTES),
      provideHttpClient(withXhr(), 
        withInterceptorsFromDi(),
        
      ),
      { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    
      provideAnimations(),
    ]
  });